import React from 'react';
import RoutePlanner from './components/RoutePlanner';
import './App.css';

function App() {
  return (
    <div className="App">
      <RoutePlanner />
    </div>
  );
}

export default App;
